var _style, _desc, _path, _g, _path2, _g2;

const _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCrossRedCircleIco(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 14.4 14.4",
    style: {
      enableBackground: "new 0 0 14.4 14.4"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill-rule:evenodd;clip-rule:evenodd;fill:#D8D8D8;}\r\n\t.st1{fill-rule:evenodd;clip-rule:evenodd;fill:#FFFFFF;}\r\n\t.st2{fill:#FFFFFF;}\r\n\t.st3{fill-rule:evenodd;clip-rule:evenodd;fill:#FF0400;}\r\n")), _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "path-1_1_",
    className: "st0",
    d: "M7.2,0C3.2,0,0,3.2,0,7.2s3.2,7.2,7.2,7.2s7.2-3.2,7.2-7.2S11.2,0,7.2,0z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "path-1_2_",
    className: "st1",
    d: "M7.2,0C3.2,0,0,3.2,0,7.2s3.2,7.2,7.2,7.2s7.2-3.2,7.2-7.2S11.2,0,7.2,0z"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "path-3_1_",
    className: "st2",
    d: "M7.9,7.1l2.4-2.4c0.2-0.2,0.2-0.6,0-0.8c-0.2-0.2-0.6-0.2-0.8,0L7.1,6.3L4.7,3.9 c-0.2-0.2-0.6-0.2-0.8,0c-0.2,0.2-0.2,0.6,0,0.8l2.4,2.4L3.9,9.5c-0.2,0.2-0.2,0.6,0,0.8c0.2,0.2,0.6,0.2,0.8,0l2.4-2.4l2.4,2.4 c0.2,0.2,0.6,0.2,0.8,0c0.2-0.2,0.2-0.6,0-0.8L7.9,7.1z"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "path-3_2_",
    className: "st3",
    d: "M7.9,7.1l2.4-2.4c0.2-0.2,0.2-0.6,0-0.8c-0.2-0.2-0.6-0.2-0.8,0L7.1,6.3L4.7,3.9 c-0.2-0.2-0.6-0.2-0.8,0c-0.2,0.2-0.2,0.6,0,0.8l2.4,2.4L3.9,9.5c-0.2,0.2-0.2,0.6,0,0.8c0.2,0.2,0.6,0.2,0.8,0l2.4-2.4l2.4,2.4 c0.2,0.2,0.6,0.2,0.8,0c0.2-0.2,0.2-0.6,0-0.8L7.9,7.1z"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrossRedCircleIco);
export default __webpack_public_path__ + "static/media/cross-red-circle-ico.be261fd66271ce4851681a9c597cf29c.svg";
export { ForwardRef as ReactComponent };